var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"image-layout",attrs:{"alt":"Mochi Trailers","src":require("../../assets/banner.png")},on:{"click":function($event){return _vm.homePage()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }